/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the MPIApiConfiguration configuration object with a given root URL.
 */
export function provideMPIApiConfiguration(rootUrl: string) {
  var config = new MPIApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: MPIApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class MPIApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `MPIModule.forRoot()`
 */
export interface MPIApiConfigurationParams {
  rootUrl?: string;
}
